import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { login } from "api/auth";
import {
  setAuthToken,
  setAuthTokenType,
  setCurrentDeviceDetails,
  setTempCurrentDeviceDetails,
  setUserDetails,
} from "utils/local-storage";

import { markStates } from "utils/misc";

export const loginThunk = createAsyncThunk(
  "auth/sendOtp",
  async (request, thunkAPI) => {
    try {
      const response = await login(request);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const tempLoginThunk = createAsyncThunk(
  "auth/tempLogin",
  async (request, thunkAPI) => {
    try {
      const response = await login(request);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const initialState = {
  isLoggedIn: false,
  loginError: null,
  deviceType: "Android",
  family: 1,
  appDisable: false,
  activeTab: "dashboard",
  ip: null,
  country: null,
  paypal_client_id:
    "AXeTVqmbaGBbHZdI23Z_wBtDD6NF7n71MK54VORvFKRoNKNHh6MnkKEnkWLIXHAM-x_3VlkGL1KW4xld",
  userDetails: {
    email: null,
    devices: null,
    email_status: "0",
  },
  currentDeviceStatusSettings: null,
  isvoiprecord: 0,
  phtonfailpin: false,
  unreadCountData: {},
  currentDevice: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    markAuthStore: (state, action) => {
      markStates(action.payload, state);
    },

    logout: (state) => {
      state.isLoggedIn = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loginThunk.pending, (state) => {
      state.isLoggedIn = false;
    });
    builder.addCase(loginThunk.fulfilled, (state, action) => {
      setAuthToken(action.payload.token);
      setAuthTokenType(action.payload.token_type);
      setUserDetails(action.payload);
      setCurrentDeviceDetails(action.payload.devices[0]);
      setTempCurrentDeviceDetails(action.payload.devices[0]);
      state.isLoggedIn = true;
      state.currentDevice = action.payload.devices[0];
      state.userDetails = action.payload;
    });
    builder.addCase(loginThunk.rejected, (state, action) => {
      state.isLoggedIn = false;
      state.loginError = action.payload.response.data.message;
    });

    builder.addCase(tempLoginThunk.pending, (state) => {
      state.isLoggedIn = false;
    });
    builder.addCase(tempLoginThunk.fulfilled, (state, action) => {
      setAuthToken(action.payload.token);
      setAuthTokenType(action.payload.token_type);
      setUserDetails(action.payload);
      setCurrentDeviceDetails(action.payload.devices[0]);
      setTempCurrentDeviceDetails(action.payload.devices[0]);
      state.isLoggedIn = true;
      state.currentDevice = action.payload.devices[0];
      state.userDetails.email = action.payload.email;
      state.userDetails.devices = action.payload.devices;
    });
    builder.addCase(tempLoginThunk.rejected, (state, action) => {
      state.isLoggedIn = false;
      state.loginError = action.payload.response.data.message;
    });
  },
});

export const { logout, markAuthStore } = authSlice.actions;

export const selectIsUserLoggedIn = (state) => state.authReducer.isLoggedIn;
export const selectDeviceType = (state) => state.authReducer.deviceType;
export const selectDeviceFamily = (state) => state.authReducer.family;
export const selectUserDetails = (state) => state.authReducer.userDetails;
export const selectUserCountryCode = (state) => state.authReducer.country;
export const selectUserIpAddress = (state) => state.authReducer.ip;
export const selectUserDevices = (state) =>
  state.authReducer.userDetails.devices;
export const selectCurrentDevice = (state) => state.authReducer.currentDevice;
export const selectCurrentDeviceStatusSettings = (state) =>
  state.authReducer.currentDeviceStatusSettings;
export const selectLoginError = (state) => state.authReducer.loginError;
export const selectIsvoiprecord = (state) => state.authReducer.isvoiprecord;
export const selectPhtonfailpin = (state) => state.authReducer.phtonfailpin;
export const selectAppDisable = (state) => state.authReducer.appDisable;
export const selectActiveTab = (state) => state.authReducer.activeTab;
export const selectpaypalClientId = (state) =>
  state.authReducer.paypal_client_id;
export const selectUnreadCountData = (state) =>
  state.authReducer.unreadCountData;

export default authSlice.reducer;
